import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { AccountData } from './account.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AccountService } from './account.service';

export class AccountDataSource implements DataSource<AccountData> {

  private dataSubject = new BehaviorSubject<AccountData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private accountService: AccountService) {}

  connect(collectionViewer: CollectionViewer): Observable<AccountData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadAccounts(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'email',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.accountService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.account);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
